import React from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {ConversationSafetyNetModel} from '../../../../../models/api/conversationSafetyNetModel';
import {ConversationSummaryDetailsSubsection} from './conversationSummaryDetailsSubsection';

/*
 * Props.
 */

interface ConversationSummarySafetyNetsProps {
  safetyNets: ReadonlyArray<ConversationSafetyNetModel>;
}

/*
 * Component.
 */

export const ConversationSummarySafetyNets: React.FC<ConversationSummarySafetyNetsProps> = ({safetyNets}) => {
  if (safetyNets.length === 0) {
    return null;
  }

  return (
    <ConversationSummaryDetailsSubsection
      title={<Trans id="conversation-summary-safetynets">SafetyNets</Trans>}
      content={renderSafetyNetsContent(safetyNets)}
      paddingTop={26}
    />
  );
};

/*
 * Helpers.
 */

function renderSafetyNetsContent(safetyNets: ReadonlyArray<ConversationSafetyNetModel>) {
  return <div>{safetyNets.map((safetyNet) => `${safetyNet.id}, `)}</div>;
}
